// extracted by mini-css-extract-plugin
export default {"sweetAlert":"ErrorHandler_sweetAlert__izcKw","sweetAlertBtnConfirm":"ErrorHandler_sweetAlertBtnConfirm__TtV-Q"};